module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ct"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#1A9540"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTENTS ")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('b', [_c('a', {
    attrs: {
      "href": "#/Text/intro#rk1",
      "id": "vk1"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("INTRODUCTION ")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('b', [_c('a', {
    attrs: {
      "href": "#/Text/chap01#rk2",
      "id": "vk2"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#F58221"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CHAPTER ONE ")])]), _c('br'), _vm._v("THANKSGIVING")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('b', [_c('span', {
    attrs: {
      "href": "#/Text/chap02#rk3",
      "id": "vk3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#D22339"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CHAPTER TWO ")])]), _c('br'), _vm._v("CHRISTMAS and"), _c('br'), _vm._v(" THE HOLIDAY SEASON")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('b', [_c('span', {
    attrs: {
      "href": "#/Text/chap03#rk4",
      "id": "vk4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#068ECB"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CHAPTER THREE ")])]), _c('br'), _vm._v("JEWISH HOLIDAYS:"), _c('br'), _vm._v(" PASSOVER, ROSH HASHANAH,"), _c('br'), _vm._v("and HANUKKAH")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('b', [_c('span', {
    attrs: {
      "href": "#/Text/chap04#rk5",
      "id": "vk5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#92528A"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CHAPTER FOUR ")])]), _c('br'), _vm._v("EASTER")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('b', [_c('span', {
    attrs: {
      "href": "#/Text/chap05#rk6",
      "id": "vk6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#FFC20A"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CHAPTER FIVE ")])]), _c('br'), _vm._v("INDEPENDENCE DAY and"), _c('br'), _vm._v("SUMMER ENTERTAINING")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('b', [_c('span', {
    attrs: {
      "href": "#/Text/chap06#rk7",
      "id": "vk7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#1A9540"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CHAPTER SIX ")])]), _c('br'), _vm._v("BRUNCHES, APPETIZERS,"), _c('br'), _vm._v(" and POTLUCK DISHES")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('b', [_c('span', {
    attrs: {
      "href": "#/Text/ack#rk9",
      "id": "vk9",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("ACKNOWLEDGMENTS ")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('b', [_c('span', {
    attrs: {
      "href": "#/Text/ack#rk10",
      "id": "vk10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("ABOUT THE AUTHOR ")])])])]), _vm._v(" "), _c('p', {
    staticClass: "serv",
    attrs: {
      "id": "pagevi"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/p-5.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9b098e46","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/toc.vue
// module id = 69
// module chunks = 0